import React from 'react';
import { Link, useHistory } from 'react-router-dom';

const FeaturedSection = ({ listings = [], isLoading = false }) => {
  const history = useHistory();

  const getDesignerName = (listing) => {
    const user = listing.users_permissions_user;
    if (!user) return 'Designer';
    if (user.firstname || user.lastname) {
      return `${user.firstname || ''} ${user.lastname || ''}`.trim();
    }
    return user.username || 'Designer';
  };

  const getDesignerSchool = (listing) => {
    const user = listing.users_permissions_user;
    return user?.school || '';
  };

  const getCoverImage = (listing) => {
    if (listing?.generatedProductPhoto?.url) return listing.generatedProductPhoto.url;
    if (!listing.photos || listing.photos.length === 0) return null;
    const coverIdx = listing.coverImageIndex || 0;
    return listing.photos[coverIdx]?.url || listing.photos[0]?.url;
  };



  if (isLoading) {
    return (
      <section className="landing-section">
        <div className="landing-section-header">
          <div>
            <div className="landing-section-label">Featured</div>
            <h2 className="landing-section-title">From Our Designers</h2>
          </div>
        </div>
        <div className="landing-designs-grid">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="landing-design-card"
              style={{ minHeight: 320, background: '#eee' }}
            />
          ))}
        </div>
      </section>
    );
  }

  if (!listings || listings.length === 0) {
    return null;
  }

  return (
    <section className="landing-section" style={{ background: '#F5F0E8' }}>
      <div className="landing-section-header">
        <div>
          <div className="landing-section-label">Featured</div>
          <h2 className="landing-section-title">From Our Designers</h2>
        </div>
        <Link to="/browse" className="landing-section-link">View all →</Link>
      </div>
      <div className="landing-designs-grid">
        {listings.map((listing) => {
          const imgUrl = getCoverImage(listing);
          const designer = getDesignerName(listing);
          const school = getDesignerSchool(listing);

          return (
            <div
              className="landing-design-card"
              key={listing.id}
              onClick={() => history.push(`/product/${listing.id}`)}
            >
              {imgUrl ? (
                <img
                  className="landing-design-img"
                  src={imgUrl}
                  alt={listing.name || 'Design'}
                />
              ) : (
                <div
                  className="landing-design-img"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#eee',
                    color: '#999',
                    fontSize: 14,
                  }}
                >
                  No Image
                </div>
              )}

              {/* Type label */}
              {(listing.isAiGenerated || listing.is3dModel) && (
                <span
                  style={{
                    position: 'absolute', bottom: 48, left: 10, zIndex: 10,
                    display: 'inline-flex', alignItems: 'center', gap: 4,
                    color: '#fff', fontSize: 10, fontWeight: 500,
                    padding: '2px 6px', borderRadius: 4,
                    background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(4px)',
                  }}
                >
                  {listing.isAiGenerated && (
                    <>
                      <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
                        <path d="M8 1L9.5 6.5L15 8L9.5 9.5L8 15L6.5 9.5L1 8L6.5 6.5L8 1Z" fill="currentColor"/>
                      </svg>
                      AI designed
                    </>
                  )}
                  {listing.is3dModel && !listing.isAiGenerated && '3D model'}
                </span>
              )}

              <div className="landing-design-info">
                <div className="landing-design-piece-name">
                  {designer}{school ? ` · ${school}` : ''}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturedSection;
